import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const CONTRACTAREASTATUS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ContractAreaStatus.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('defaultYear', 'Entity.ContractAreaStatus.DefaultYear')
    .build(),
];

export const CONTRACTAREASTATUS_CONFIG = {
  entityName: 'ContractAreaStatus',
  localizationKey: 'Controlling::Entity.ContractAreaStatus',
  fields: CONTRACTAREASTATUS_FIELDS,
  permission: 'ControllingContract.ContractAreaStatuses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
